import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const name = "common";

export interface ICommon {
  bookmarkCount: number;
  bookmarkTargetCount: number;
}

const commonSlice = createSlice({
  name,
  initialState: {
    bookmarkCount: 0,
    bookmarkTargetCount: 0,
  } as ICommon,
  reducers: {
    rdxSetBookmarkCount(state: ICommon, action: PayloadAction<number>) {
      state.bookmarkCount = action.payload;
    },
    rdxSetTargetCount(state: ICommon, action: PayloadAction<number>) {
      state.bookmarkTargetCount = action.payload;
    },
    rdxResetBookmark(state: ICommon) {
      state.bookmarkCount = 0;
      state.bookmarkTargetCount = 0;
    },
  },
});

export const { rdxSetBookmarkCount, rdxSetTargetCount, rdxResetBookmark } = commonSlice.actions;
export default commonSlice.reducer;
